import api from "./api";

export const getPickupLocationByCode = pickupLocationId =>
  api.get({
    path: `/locations/${pickupLocationId}`,
  });
